import imageCompression from "browser-image-compression";

export const ACCEPTED_IMAGE_MIME_TYPES = new Set([
	"image/jpeg",
	"image/jpg",
	"image/png",
	"image/webp",
]);

export const ACCEPTED_IMAGE_EXTENSIONS = ".jpg,.jpeg,.png,.webp";
export const MAX_INPUT_IMAGE_FILE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_OUTPUT_IMAGE_FILE_SIZE_BYTES = 1 * 1024 * 1024;
export const MAX_IMAGE_DIMENSION = 1920;

export function validateInitialImageFile(file, maxInputBytes = MAX_INPUT_IMAGE_FILE_SIZE_BYTES) {
	if (!file) {
		return "Please select an image file.";
	}

	const fileType = String(file.type || "").toLowerCase();
	if (!ACCEPTED_IMAGE_MIME_TYPES.has(fileType)) {
		return "Only JPG, JPEG, PNG, and WEBP images are allowed.";
	}

	if (file.size > maxInputBytes) {
		return `Image exceeds 5MB limit (${(file.size / 1024 / 1024).toFixed(1)}MB).`;
	}

	return null;
}

export async function compressImageForUpload(file) {
	const compressedFile = await imageCompression(file, {
		maxSizeMB: 1,
		maxWidthOrHeight: MAX_IMAGE_DIMENSION,
		useWebWorker: true,
		initialQuality: 0.85,
		fileType: file.type,
	});

	if (compressedFile.size > MAX_OUTPUT_IMAGE_FILE_SIZE_BYTES) {
		throw new Error("Unable to compress image below 1MB. Please choose a different image.");
	}

	return compressedFile;
}
